import { RestUrl } from "../common/cyan.types";

export class FolderSharingLinkUrl {
  public static getFolderSharingLink: RestUrl = ["GET", "/folder/sharing/link"];
  public static getOrganizationBySharingLink: RestUrl = ["GET", "/folder/sharing/organization"];
  public static getSharingSummaryByLinkToken: (token: string) => RestUrl = token => ["GET", `/folder/sharings/${token}`];
  public static getFoldersSummaryBySharingLink: RestUrl = ["POST", "/folder/sharing/folders/get-summary"];
  public static browseFolderBySharingLink: RestUrl = ["GET", "/folder/sharing/browse"];
  public static getFolderFileBySharingLink: (fileId: bigint) => RestUrl = id => ["GET", `/folder/sharing/files/${id}`];
  public static downloadFolderFileBySharingLink: (fileId: bigint) => RestUrl = id => ["POST", `/folder/sharing/files/${id}/download`];
  public static getFolderFileDocsPdfPageBySharingLink: (fileId: bigint, page: number) => RestUrl = (id, page) => [
    "GET",
    `/folder/sharing/files/${id}/docs-pdf/pages/${page}`,
  ];
  public static getProposalVersionsBySharingLink: (proposalId: bigint) => RestUrl = id => [
    "GET",
    `/folder/sharing/proposals/${id}/versions`,
  ];
  public static getProposalVersionBySharingLink: (proposalId: bigint, proposalVersionId: bigint) => RestUrl = (
    proposalId,
    proposalVersionId
  ) => ["GET", `/folder/sharing/proposals/${proposalId}/versions/${proposalVersionId}`];
  public static createFolderSharingLinkAccessToken: RestUrl = ["POST", "/folder/sharing/link/access-tokens"];
}
